import React from "react";

import styled from "styled-components";

import { MessageInput, isMessageDocEmpty } from "components/atoms/message";
import Text from "components/atoms/text/Text";

const Overlay = styled.div`
    position: fixed;
    z-index: 92;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: min(400px, calc(100vw - 32px));
    padding: 12px;
    border: solid 1px var(--color-Line);
    border-radius: 8px;
    background-color: var(--color-White);
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);
`;

const SelectedText = styled(Text).attrs({
    variant: "body-sm-400",
    color: "var(--color-SubBlack)",
})`
    display: block;
    overflow: hidden;
    padding: 8px;
    border-radius: 4px;
    background-color: var(--color-Base1);
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const AiRequestLabel = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--color-SubBlack);
    font-size: 1.2rem;
    user-select: none;

    input {
        margin: 0;
    }
`;

function clampPosition(position) {
    const top = Math.max(12, Math.min(window.innerHeight - 220, Number(position?.top || 0)));
    const left = Math.max(12, Math.min(window.innerWidth - 416, Number(position?.left || 0)));
    return { top, left };
}

function NoteReviewComposerOverlay({
    draft,
    isLoading,
    mentions,
    onRequestAIChange,
    onChange,
    onClose,
    onSubmit,
    position,
    requestAI,
    selectedText,
}) {
    const safePosition = clampPosition(position);
    return (
        <Overlay
            aria-label="리뷰 작성"
            style={{ top: safePosition.top, left: safePosition.left }}
            onMouseDown={(event) => event.stopPropagation()}
        >
            <Text variant="body-md-500" color="var(--color-SubBlack)">
                리뷰 추가
            </Text>
            <SelectedText>{selectedText || "선택 영역"}</SelectedText>
            <MessageInput
                autoFocus
                cancelLabel="취소"
                disabled={isLoading}
                mentions={mentions}
                placeholder="리뷰 내용을 입력하세요."
                submitDisabled={isLoading || (isMessageDocEmpty(draft) && !requestAI)}
                submitLabel="등록"
                submitLoading={isLoading}
                submitTooltip="리뷰 등록"
                value={draft}
                bottomSlot={
                    <AiRequestLabel>
                        <input
                            type="checkbox"
                            checked={requestAI}
                            disabled={isLoading}
                            onChange={(event) => onRequestAIChange?.(event.target.checked)}
                        />
                        AI 자동 응답
                    </AiRequestLabel>
                }
                onCancel={onClose}
                onChange={onChange}
                onSubmit={onSubmit}
            />
        </Overlay>
    );
}

export default NoteReviewComposerOverlay;
